/* tabella in modalità filtra (lettura dati iniziale con filtri a disposizione) */
export const FILTER = "FILTER";
/* tabella in modalità ricerca ( no lettura dati iniziale e campi ricerca disposizione) */
export const SEARCH = "SEARCH"; 